<script setup>
import { twMerge } from "tailwind-merge";

const props = defineProps({
    class: String,
});
</script>
<template>
    <tbody :class="twMerge('divide-y divide-gray-100 dark:divide-gray-800', props.class)">
        <slot></slot>
    </tbody>
</template>
